'use strict';

angular.module('formonlineApp')
    .controller('FooterController', function ($scope, $location, $state, Auth, Principal, toolbarSettings) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;

		$scope.buttons = null;

		this.init = function(buttons) {
			$scope.buttons = buttons;
		};

		toolbarSettings.setCallback(this.init);
    });
